import Common from "../../../Common";

export interface PBXQueueCallerPriority {
	id?: id
	name: string
	description?: string
	priority: id
	pbx_destination_id: id
}

export type PBXQueueCallerPriorityRead = PBXQueueCallerPriority & {
	id: id
	src_pbx_destination_id: id
}

export interface PBXQueueCallerPriorityBrowse {
	id: id
	name: string
}

const QueueCallerPriority = class extends Common {
	browse = (companyId: id): CustomResponse<PBXQueueCallerPriorityBrowse[]> =>
		this.get(`/company/${companyId}/pbx/queuecallerpriority`);

	read = (companyId: id, id: id): CustomResponse<PBXQueueCallerPriorityRead> =>
		this.get(`/company/${companyId}/pbx/queuecallerpriority/${id}`);

	create = (companyId: id, data: any, options?: DadExtraOptions) =>
		this.post(`/company/${companyId}/pbx/queuecallerpriority${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data);

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/queuecallerpriority/${id}`);
}

export default QueueCallerPriority
